import fetch from '@/common/js/http';
import {SET_LOGINUSER, REMOVE_LOGINUSER} from "../mutation-types";
import {
    setToken, setUserInfo, removeToken
    , removeUserInfo, getUserInfo
} from "@/common/js/auth";

const employee = {
    namespaced: true,
    state: {
        token: '',
        employeeInfo: null,
        isLogin: false
    },
    mutations: {
        [SET_LOGINUSER](state, {yc_token, employee}) {
            state.employeeInfo = employee
            state.isLogin = true
            state.token = yc_token

            setToken(yc_token)
            setUserInfo(employee)
        },
        [REMOVE_LOGINUSER](state) {
            state.employeeInfo = null
            state.isLogin = false
            state.token = ''

            removeToken()
            removeUserInfo()
        }
    },
    actions: {
        login({commit}, {loginName, password, openId}) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'login',
                    method: 'post',
                    data: {
                        loginName: loginName,
                        password: password,
                        openId: openId
                    }
                }).then(success => {
                    resolve(success)
                    if (success && success.data) {
                        commit(SET_LOGINUSER, {yc_token: success.data.token, employee: success.data.data})
                    }
                }, error => {
                    reject(error)
                })
            })
        },
        logout({commit}) {
            commit(REMOVE_LOGINUSER)
            localStorage.clear()
        },
        changePwd({commit},newPwd) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'changePwd',
                    method: 'post',
                    data: { password: newPwd}
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },

        /*******************************************************************************/

        getAllUsers({commit}) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'user/all',
                    method: 'get',
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        getAllUsersValid({commit}) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'user/validall',
                    method: 'get',
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        postAllUsersCountUt({commit}, params) {
          return new Promise((resolve, reject) => {
              return fetch({
                  url: 'v2/user/countUt',
                  method: 'post',
                  data: params
              }).then(success => {
                  resolve(success)
              }, error => {
                  reject(error)
              })
          })
        },
        postAllUsersClearUt({commit}, params) {
          return new Promise((resolve, reject) => {
              return fetch({
                  url: 'v2/user/clearUt',
                  method: 'post',
                  data: params
              }).then(success => {
                  resolve(success)
              }, error => {
                  reject(error)
              })
          })
        },
        getMonthOrYearUt({commit}, params) {
          return new Promise((resolve, reject) => {
              return fetch({
                  url: 'v2/user/monthOrYearUt',
                  method: 'get',
                  params: params
              }).then(success => {
                  resolve(success)
              }, error => {
                  reject(error)
              })
          })
        },
        getHistoryNotCommitUt({commit}, params) {
          return new Promise((resolve, reject) => {
              return fetch({
                  url: 'v2/user/historyNotCommitUt',
                  method: 'get',
                  params: params
              }).then(success => {
                  resolve(success)
              }, error => {
                  reject(error)
              })
          })
        },
        getUserWithPage({commit}, params) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'user/page',
                    method: 'get',
                    params: params
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        createUser({commit}, user) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'user',
                    method: 'put',
                    data: user
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        saveUser({commit}, user) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'user',
                    method: 'post',
                    data: user
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        getUserProject({commit}, loadHistory) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'user/project',
                    method: 'get',
                    params: {"loadHistory": loadHistory}
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },

        /*******************************************************************************/

        getUserConsumeWithPage({commit},params) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'user/consume/page',
                    method: 'get',
                    params: params
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        createConsume({commit}, consume) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'user/consume',
                    method: 'put',
                    data: consume
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        getConsume({commit}, {date, loadHistory}) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'user/consume',
                    method: 'get',
                    params: {date: date, loadHistory: loadHistory}
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        saveConsume({commit}, consume) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'user/consume',
                    method: 'post',
                    data: consume
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        getUserConsumeGroupList({commit}, obj) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'user/consume/groupList',
                    method: 'get',
                    params: obj
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },

        /*******************************************************************************/

        getAllLevelConfig({commit}) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'user/levelConfig/all',
                    method: 'get'
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        getLevelConfigWithPage({commit},params) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'user/levelConfig/page',
                    method: 'get',
                    params:params
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        saveLevelConfig({commit}, lc) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'user/levelConfig',
                    method: 'post',
                    data: lc
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        createLevelConfig({commit}, lc) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'user/levelConfig',
                    method: 'put',
                    data: lc
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        
         /************************************ 人员绩效管理 **********************************/
        
        // 获取人员绩效列表
        getEmployeeAvailabilityList({commit},params){
            return new Promise((resolve,reject)=>{
                return fetch({
                    url:"performance/user",
                    method:"get",
                    params:params
                }).then(success=>{
                    resolve(success)
                },error=>{
                    reject(error)
                })
            })
        },
        userOperate({commit},params){
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'user/operate',
                    method: 'put',
                    data: params
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },

        /************************************ 微信 **********************************/
        // 个人驳回
        getRejectList({commit},params){
            return new Promise((resolve,reject)=>{
                return fetch({
                    url:'user/reject',
                    method:'get',
                    params:params
                }).then(success=>{
                    resolve(success)
                },error=>{
                    reject(error)
                })
            })
        },
        // 个人驳回删除
        deleteRejectList({cmmmit}) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'user/reject',
                    method: 'delete',
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        getAllUsersValidV2({commit}) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: '/v2/user/valid/all',
                    method: 'get',
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
    }
}

export default employee



// WEBPACK FOOTER //
// ./src/vuex/modules/employee.js